<template>
  <Popper
    hover
    :interactive="false"
    :openDelay="delay"
    :placement="placement"
  >
    <template #content>
      <div class="popper_ziggu">
        <slot name="tip" />
      </div>
    </template>
    <slot name="content" />
  </Popper>
</template>

<script setup>
import Popper from 'vue3-popper';

defineProps({
  placement: { type: String, default: 'top' },
  delay: { type: Number, default: 300 },
});
</script>
